import { ACORN_PROJECT_NAME } from '@web-platform/shared-universal-constants/src/project';

export const PQS_MINI_RATING = 'pqs.Rating';
export const PQS_MINI_EXPERIENCE = 'pqs.Experience';
export const ACORN_FLIGHTS_BOOKING_PANEL_FETCH = 'acorn.FlightsBookingPanelFetch';
export const ACORN_FLIGHT_PARTNER_SELECTED = 'acorn.FlightPartnerSelected';
export const ACORN_LIVE_PRICES_DISPLAYED = 'acorn.LivePricesDisplayed';
export const ACORN_FLIGHTS_DAY_VIEW_NO_RESULTS = 'acorn.FlightsDayViewNoResults';
export const AD_SPONSORED_CONTENT_WIDGET_LOAD = 'sponsored.AdSponsoredContentWidgetLoad';
export const AD_SPONSORED_CONTENT_WIDGET_ENGAGE = 'sponsored.AdSponsoredContentWidgetEngage';
export const AD_SPONSORED_CONTENT_WIDGET_ELEMENT_CLICK =
  'sponsored.AdSponsoredContentWidgetElementClick';
export const AD_SPONSORED_CONTENT_WIDGET_ELEMENT_ENGAGE =
  'sponsored.AdSponsoredContentWidgetElementEngage';
export const EVENT_PRODUCER_NAME = ACORN_PROJECT_NAME;
export const TIME_UNIT_MINUTE = 'MINUTE';
export const TIME_UNIT_SECOND = 'SECOND';
export const BOOKING_PANEL_REQUEST_TYPE = {
  FIRST: 'FIRST',
  REFRESH: 'REFRESH',
};

export type EventProducerName = typeof EVENT_PRODUCER_NAME;
